import React from "react";
import logo from "../../../assets/images/logo.png";
// import { maskString } from "../../../helpers/serviceHelpers";
import { Box, Chip, Typography, useTheme } from "@mui/material";

const ApplicationDetails: React.FC<{
  title: string;
  machineStatus: string;
  image_url: string;
  model: string;
  status: string;
}> = ({ title, machineStatus, image_url, model, status }) => {
  const theme = useTheme();
  return (
    <Box className="flex flex-row items-center bg-white">
      <img
        className="w-28 h-28 bg-white"
        src={image_url ?? logo}
        alt={`${title}`}
      />
      <Box className="flex-1 flex flex-col">
        <Chip
          sx={{ alignSelf: "start" }}
          variant="outlined"
          color="primary"
          size="small"
          label={status}
        />

        <Box>
          <Typography variant="h6">{title}</Typography>
          <Typography variant="body2">{model}</Typography>
          {machineStatus !== "" && (
            <Typography
              bgcolor={
                machineStatus === "Out of Warranty"
                  ? theme.palette.error.main
                  : machineStatus === ""
                  ? theme.palette.warning.main
                  : theme.palette.success.main
              }
              color="white"
              p={.3}
              lineHeight={1}
              variant="caption"
              borderRadius={1}
            >
              {machineStatus}
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ApplicationDetails;
